module.exports = __webpack_public_path__ + "img/golang.eded3ee4.png";